import React, { ReactElement } from 'react'

import { FieldPrefix } from '../../../../../../1stlog-ui/src/components/Field'
import Name from './Name'
import TypesSelect from './TypesSelect'

type TNotificationProps = {
  name: string
}

const Notification = (props: TNotificationProps): ReactElement => {
  const { name } = props

  return (
    <FieldPrefix prefix={name}>
      <div className="">
        <div>
          <Name name={name} />
        </div>
        <div className="ml-4 mb-2 mt-0">
          <TypesSelect />
        </div>
      </div>
    </FieldPrefix>
  )
}

export default Notification
